<template>
	<permits-item v-if="show" :color="'#4CAF50'">
		<div class="c1">
			<div class="icon"></div>
			<div>
				<h1>{{ $t('IDICARE App') }}</h1>
				<p>{{ $t('Our app is fast, small, and works offline.') }}</p>
			</div>
		</div>
		<template v-slot:footer>
			<action-button :color="'rgba(0,0,0,0.5)'" :title="$t('Install')" @click="requestInstall" />
		</template>
	</permits-item>
</template>

<script>
import { mapGetters } from 'vuex'
import PermitsItem from '@/modules/permits/PermitsItem'
import ActionButton from '@/modules/ui/ActionButton'
export default {
	name: 'permits-item-install',
	components: {
		PermitsItem,
		ActionButton
	},
	methods: {
		requestInstall() {
			this.$root.$emit('install-request', {})
		}
	},
	computed: {
		show() {
			return this.install.prompt
		},
		...mapGetters({
			install: 'GET_INSTALL'
		})
	}
}
</script>

<style scoped>
.c1 {
	display: flex;
}
.icon {
	margin: 15px 0 0 10px;
	display: block;
	width: 50px;
	height: 50px;
	flex: 0 0 50px;
	background-image: url(/static/svg/logos/logo-white-simple.svg);
	background-position: center;
	background-repeat: no-repeat;
	background-size: 60px;
}
</style>



// WEBPACK FOOTER //
// src/modules/permits/PermitsItemInstall.vue